
import {
  Component,
  ChangeDetectionStrategy,
  Input
} from '@angular/core';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'zef-fade-animation',
  templateUrl: './fade-animation.component.html',
  styleUrls: ['./fade-animation.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FadeAnimationComponent {
  @Input()
  animationState: boolean;

  @Input()
  animationParams: {
    duration?: string;
    enterDuration?: string;
    leaveDuration?: string;
    easing?: string;
  };

  // Fed into the template as inline CSS custom properties. `duration` acts as a
  // fallback for both directions so it is no longer an inert param.
  get enterDuration() {
    return this.animationParams?.enterDuration ?? this.animationParams?.duration;
  }

  get leaveDuration() {
    return this.animationParams?.leaveDuration ?? this.animationParams?.duration;
  }

  get easing() {
    return this.animationParams?.easing;
  }
}
